import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p style="margin-bottom: 7.5pt;">
      <strong><span
        style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
        lang="EN-US">Description</span></strong>
    </p>
    <p style="margin-bottom: 7.5pt;">
        <span
          style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
          lang="EN-US">
            This action was generated because either (A) 3 or more PNOVC packages were returned by the driver that marked them missing, OR (B) an OV package was Verify Scanned during loadout, marked missing on road, and return to station at end
            of the day all by the same driver.
        </span>
    </p>
    <p style="margin-bottom: 7.5pt;">
      <strong><span
        style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
        lang="EN-US">Impact</span></strong>
    </p>
    <p style="margin-bottom: 7.5pt;">
        <span
          style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
          lang="EN-US">
            PNOV-Compliant packages create extra stops for drivers, decrease route efficiency, and a cost impact. Overall, this causes customer dissatisfaction due to potential delays in delivery.
        </span>
    </p>
    <p style="margin-bottom: 7.5pt;">
      <strong><span
        style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
        lang="EN-US">Resolution Steps</span></strong>
    </p>
    <p style="margin-bottom: 7.5pt;">
        <span
          style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
          lang="EN-US">
            Please fill out the following questionnaire to help the station identify potential process improve opportunities and remove driver barriers.
        </span>
    </p>
    <ul>
      <li>
            <span
              style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
              lang="EN-US">
                Who was talked to regarding this action?&nbsp;
            </span>
        <span
          style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
        >
                DA/DSP Owner/ Dispatch
            </span>
      </li>
      <li>
        <span
          style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
          lang="EN-US">When did the conversation occur?&nbsp;</span>
        <span
          style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
        >
                During RTS/On-Road Gemba
            </span>
      </li>
      <li>
        <span
          style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
          lang="EN-US">Did the driver consolidate bags?&nbsp;</span>
        <span
          style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
        >
                Yes/No
            </span>
      </li>
      <li>
            <span
              style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
              lang="EN-US">
                Where did the driver find the “Missing” package? A different bag/Mixed with OV/Random Place in the Van/Do not Recall
            </span>
      </li>
      <li>
            <span
              style="background: white; color: rgb(51, 51, 51); line-height: normal; tab-stops: list 36pt; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: black;"
              lang="EN-US">
                What prevented the driver from re-attempting the 'Missing' Package? I did not know packages should be reattempted/ I did not know how to reattempt a package/I ran out of time
            </span>
      </li>
    </ul>
    <p style="margin-bottom: 7.5pt;">
      <strong><span
        style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
        lang="EN-US">Supplemental Links</span></strong>
    </p>
    <p style="margin-bottom: 7.5pt;">
      <span
        style="background: white; line-height: normal; font-size: 10.5pt; font-family: 'Arial', sans-serif; color: rgb(51, 51, 51);"
        lang="EN-US">1)&nbsp;</span>
      <span style="background: white; line-height: normal;">
            <span className="wikiinternallink">
                <a href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/c138825e-cdb4-4915-b93c-a76ac43f28db?">
                    <span style="background: white; line-height: normal; font-size: 10.5pt; font-family: ;" lang="EN-US">PNOV Quicksight</span>
                </a>
            </span>
        </span>
      <br/>
      <span
        style="
                background: white;
                line-height: normal;
                font-size: 10.5pt;
                font-family: 'Arial', sans-serif;
                color: rgb(51, 51, 51);
                font-size: 10.5pt;
                font-family: 'Arial', sans-serif;
                color: rgb(0, 136, 204);
                font-size: 10.5pt;
                font-family: 'Arial', sans-serif;
                color: rgb(51, 51, 51);
            "
        lang="EN-US"
      >
            2)&nbsp;
        </span>
      <span style="background: white; line-height: normal;">
            <span className="wikiinternallink">
                <a
                  href="https://amazonprojects.corp.amazon.com/sites/AMZLACES2/processdocs/SOPs/Reattempting%20Packages%20Missing.pdf">
                    <span style="background: white; line-height: normal; font-size: 10.5pt; font-family: ;" lang="EN-US">Re-Attempt SOP</span>
                </a>
            </span>
        </span>
    </p>
  </div>`
)


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_PNOVRTS.jsx